import { Action, createReducer, on } from '@ngrx/store';
import * as youtubeModal from '../actions/youtube-modal';

export interface State {
  visible: boolean;
  id: string;
}

const initialState: State = {
  visible: false,
  id: ''
};

export const youtubeReducer = createReducer(
  initialState,
  on(youtubeModal.ToggleYoutubeModalAction, (state, action) => {
    const visible =
      action.payload !== undefined ? action.payload : !state.visible;
    return Object.assign({}, state, { visible });
  }),
  on(youtubeModal.ChangeVideoIdAction, (state, action) => {
    return Object.assign({}, state, { id: action.payload, visible: true });
  })
);

export function reducer(state: State | undefined, action: Action): State {
  return youtubeReducer(state, action);
}

export const isVisible = (state: State) => state.visible;
export const videoId = (state: State) => state.id;
